import * as angular from 'angular';

"use strict";

angular.module('LoginAttemptsModule', []);

export default 'LoginAttemptsModule';
